import { FC } from 'react';
import { Button, UIText2 } from '@cian/ui-kit';

import * as styles from './style.css';
import { NBSP } from 'shared/constants/symbols';

interface IOnboardingContentProps {
  onClick: () => void;
}

export const OnboardingContent: FC<IOnboardingContentProps> = ({ onClick }) => {
  return (
    <div className={styles['container']} data-testid="MortgageFilterOnboarding">
      <UIText2 color="text-inverted-default">
        Теперь можно искать по{NBSP}платежу и{NBSP}программе
      </UIText2>
      <div>
        <Button size="XS" theme="fill_primary" onClick={onClick}>
          Будем знать
        </Button>
      </div>
    </div>
  );
};
